import React, { createContext, useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  baseUrl,
  checkAuthenticateApi,
  parichayapiLogout,
  parichayTokenAuthenticate,
} from "./Config";
import {
  checkAuthenticityApi,
  checkParichayAuthenticityApi,
  parichayLogoutApi,
} from "../services/api";

const ShowManualDataContext = createContext();

export const useShowManualData = () => useContext(ShowManualDataContext);

export const ShowManualDataProvider = ({ children }) => {
  const printRef = React.useRef();
  const location = useLocation();
  const dispatch = useDispatch();
  const getSlug = location?.pathname?.split("/").pop() || "";
  const activeScreen = location?.pathname?.split("/")[1] || "";
  const actualSlug = getSlug?.replace("#", "");
  const [isBlurred, setIsBlurred] = useState();
  const [activeTab, setActiveTab] = useState("");
  const [isAdmin, setIsAdmin] = useState();
  const isParichayAuthenticated = localStorage.getItem(`parichay_login`)
    ? true
    : undefined;
  const userId = localStorage.getItem(`nic_front_userId`);
  const token = localStorage.getItem(`nic_front_authToken`);
  const getManualDataType = JSON.parse(localStorage.getItem(`showManualData`));

  const [showManualData, setShowManualData] = useState(
    getManualDataType || {
      toolReport: false,
      surveyReport: false,
      overAllReport: false,
      dbims_report: false,
      dbim_manual_report: false,
      dbims_overall_report: false,
    }
  );
  const [manualRecord, setManualRecord] = useState({
    user_id: "",
    site_id: "",
    data: {
      security_privacy: [],
      performance_technical: [],
      content_information: [],
      integration_service: [],
      interactivity_engagement: [],
    },
  });

  const [dbim_manualRecord, setDbimManualRecord] = useState({
    user_id: "",
    site_id: "",
    data: {
      coloursQuestion: [],
      content_questions: [],
      iconographyQuestion: [],
      imagery_questions: [],
      logo_lockup_questions: [],
      header_and_footer: [],
      search_functionality_questions: [],
    },
  });

  const parichayLogout = React.useCallback(() => {
    if (isParichayAuthenticated) {
      const apiUrl = `${baseUrl}${parichayapiLogout}${userId}`;
      dispatch(parichayLogoutApi({ apiUrl, token }));
    }
  }, [baseUrl, parichayLogoutApi]);

  const checkParichayAuthenticity = React.useCallback(() => {
    const apiUrl = `${baseUrl}${parichayTokenAuthenticate}${userId}`;
    dispatch(checkParichayAuthenticityApi({ apiUrl, token }));
  }, [userId, baseUrl, checkParichayAuthenticityApi]);

  const checkAuthenticity = React.useCallback(() => {
    const apiUrl = `${baseUrl}${checkAuthenticateApi}`;
    dispatch(checkAuthenticityApi({ apiUrl, token }));
  }, [userId, baseUrl, checkAuthenticityApi]);

  return (
    <ShowManualDataContext.Provider
      value={{
        printRef,
        actualSlug,
        showManualData,
        activeTab,
        isBlurred,
        isAdmin,
        activeScreen,
        manualRecord,
        dbim_manualRecord,
        setDbimManualRecord,
        setManualRecord,
        setIsAdmin,
        setActiveTab,
        setShowManualData,
        setIsBlurred,
        parichayLogout,
        checkParichayAuthenticity,
        checkAuthenticity,
      }}
    >
      {children}
    </ShowManualDataContext.Provider>
  );
};
